var _circle, _circle2, _rect, _ellipse, _ellipse2, _rect2, _line, _line2, _line3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "pastorGradient",
    cx: "50%",
    cy: "30%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#5F7A61",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F5F0E6",
      stopOpacity: 0.3
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#pastorGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 22,
    r: 8,
    fill: "#E5DECF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 16,
    height: 20,
    fill: "#1C1917",
    rx: 8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 36,
    rx: 4,
    ry: 8,
    fill: "#1C1917"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46,
    cy: 36,
    rx: 4,
    ry: 8,
    fill: "#1C1917"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 42,
    width: 12,
    height: 8,
    fill: "#5F7A61",
    rx: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 44,
    x2: 36,
    y2: 44,
    stroke: "#FFFFFF",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 46,
    x2: 36,
    y2: 46,
    stroke: "#FFFFFF",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 48,
    x2: 36,
    y2: 48,
    stroke: "#FFFFFF",
    strokeWidth: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 15,
    r: 6,
    fill: "none",
    stroke: "#5F7A61",
    strokeWidth: 2,
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastorIcon);
export default __webpack_public_path__ + "static/media/pastor-icon.a5b1e219c2b9955670caca6cf3b18141.svg";
export { ForwardRef as ReactComponent };